import { axios } from './axios';
import { handleErrors } from './utils';

const VIEWS_ENDPOINT = '/views/v1';

/**
 * Get all views from B4 API
 * @returns {Promise<Array>} List of all views
 */
export function getAll() {
    return new Promise((resolve, reject) => {
        axios
            .get(`${VIEWS_ENDPOINT}/`)
            .then(({ data }) => resolve(data))
            .catch(handleErrors(reject));
    });
}

/**
 * Delete a view by ID
 * @param {number|string} id - View ID
 * @returns {Promise} Deletion result
 */
export function remove(id) {
    if (!id) return Promise.reject('View ID is required');

    return new Promise((resolve, reject) => {
        axios
            .delete(`${VIEWS_ENDPOINT}/${id}`)
            .then(({ data }) => resolve(data))
            .catch(handleErrors(reject));
    });
}

/**
 * Transform views from B4 API format to internal format
 *
 * B4 format: { view_id, name, entity, is_public, report_id, filter }
 * Internal:  { id, name, entity, isPublic, reportId, filter }
 *
 * @param {Array} apiViews - Views array from B4 API
 * @returns {Array} Transformed views
 */
export function transformViewsFromApi(apiViews) {
    if (!Array.isArray(apiViews)) return [];

    return apiViews.map((view) => ({
        id: view.view_id,
        name: view.name,
        entity: view.entity,
        isPublic: view.is_public ? 'True' : 'False',
        reportId: view.report_id,
        filter: view.filter,
    }));
}
